module.exports = __webpack_public_path__ + "media/images/youtube-462d9a023ec9b5037fee4e116b078e44.png";